import { Icons, HexIcon, tokens } from '@cast/design-system';
import { TrialBannerLayout, useTrial } from '@cast/shared-trial-ui';

import { useIsClusterDemoMode } from '@cast/infrastructure-demo';
import { useIsOrganizationReadOnly } from 'hooks/useIsOrganizationReadOnly';

export const TrialJustStartedBanner = () => {
  const accountReadOnly = useIsOrganizationReadOnly();
  const { isEligible, state, expiresInDays } = useTrial();
  const isClusterDemoMode = useIsClusterDemoMode();

  if (
    accountReadOnly ||
    !isClusterDemoMode ||
    !isEligible ||
    state !== 'active' ||
    expiresInDays <= 20
  ) {
    return null;
  }

  return (
    <TrialBannerLayout
      testId="trial-just-started-banner"
      icon={
        <HexIcon
          icon={<Icons.Lightning />}
          size={58}
          iconColor={tokens.theme.fg.status.success}
          hexColor={tokens.theme.data.green400}
        />
      }
      title="Your trial just started. Connect your cluster to feel the power!"
      description="Unlock your cluster’s full potential with our advanced monitoring, autoscaling and security technologies. Try it for free for 30 days and see how it makes impact to your cluster. After that, no auto payments will be made - we’ll send a reminder to you to decide."
    />
  );
};
